"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var util_1 = require("../util");
var ShieldCheck = function (props) {
    var _a = (0, util_1.getVariantClassNames)(props), primary = _a.primary, secondary = _a.secondary;
    return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
        react_1.default.createElement("path", { d: "M6.66667 6.66667L19.4167 4.25C19.8333 4.16667 20.25 4.16667 20.6667 4.25L33.3333 6.66667V22.1667C33.3333 27.0833 30.8333 31.5833 26.6667 34.1667L20.9167 37.75C20.4167 38.0833 19.6667 38.0833 19.1667 37.75L13.3333 34.1667C9.16667 31.5833 6.66667 27 6.66667 22.1667V6.66667Z", className: primary }),
        react_1.default.createElement("path", { d: "M18.6667 24.5833C18.25 24.5833 17.8333 24.4167 17.5833 24.0833L14.4167 20.9167C13.75 20.25 13.75 19.3333 14.4167 18.6667C15.0833 18 16.0833 18 16.6667 18.6667L18.75 20.75L24 15.5C24.6667 14.8333 25.5833 14.8333 26.25 15.5C26.9167 16.1667 26.9167 17.0833 26.25 17.75L19.8333 24.1667C19.4167 24.4167 19 24.5833 18.6667 24.5833Z", className: secondary })));
};
exports.default = ShieldCheck;
